import gql from 'graphql-tag';
import React, { useRef, useState } from 'react';
import { Query, withApollo } from 'react-apollo';
import Select, { Async, components } from 'react-select';
import { customDropdownBridgeStyles } from './commons';

const SEARCH_BRIDGE_PAYERS = gql`
  query searchBridgePayers($search: String) {
    searchBridgePayers(search: $search) {
      id
      code
      name
      memberId
      hint
      bridgeId
    }
  }
`;

const PayersDropDown = ({ client, onPayerChange, selectedPayer }) => {
  const asyncSelect = useRef();
  const [inputValue, setInputValue] = useState();
  const [isFetching, setIsFetching] = useState(false);

  const handleInputChange = (newValue) => {
    const inputValue = newValue;
    setInputValue(inputValue);
    return inputValue;
  };

  const loadOptions = async (inputValue, callback) => {
    // if (!inputValue || inputValue.length < 2) {
    //   callback(null);
    //   return;
    // }
    setIsFetching(true);

    const payers = await client.query({
      query: SEARCH_BRIDGE_PAYERS,
      variables: {
        search: inputValue,
      },
    });

    if (!payers || !payers.data || !payers.data.searchBridgePayers) {
      callback([]);
    }

    console.log(payers.data.searchBridgePayers.map((x) => `${x.name} - ${x.id}`));
    callback(
      payers.data.searchBridgePayers.map((x) => {
        return {
          label: x.name,
          value: x.id,
          ...x,
        };
      })
    );
    setIsFetching(false);
  };

  return (
    <Query query={SEARCH_BRIDGE_PAYERS} variables={{ search: '' }} fetchPolicy="network-only">
      {({ data, loading }) => {
        if (!!loading) {
          return (
            <Async
              ref={asyncSelect}
              styles={customDropdownBridgeStyles}
              isClearable
              loadOptions={loadOptions}
              defaultOptions={[]}
              cacheOptions={false}
              value={selectedPayer}
              isLoading={!!loading}
              inputValue={inputValue}
              onInputChange={handleInputChange}
              placeholder="Insurance Provider"
              noOptionsMessage={() => (inputValue ? (inputValue.length > 2 ? inputValue : 'Minimum 2 characters to search') : 'Minimum 2 characters to search')}
              onChange={(option) => {
                console.log({ option });
                onPayerChange(option);
              }}
            />
          );
        }
        const res = (data.searchBridgePayers || []).map((x) => {
          return {
            label: x.name,
            value: x.id,
            ...x,
          };
        });

        return (
          <Async
            ref={asyncSelect}
            menuPortalTarget={document.body}
            styles={customDropdownBridgeStyles}
            isClearable
            loadOptions={loadOptions}
            defaultOptions={res}
            cacheOptions={false}
            value={selectedPayer}
            // isLoading={!!loading}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            placeholder="Insurance Provider"
            noOptionsMessage={() => (inputValue ? (inputValue.length > 2 ? inputValue : 'Minimum 2 characters to search') : 'Minimum 2 characters to search')}
            onChange={(option) => {
              onPayerChange(option);
            }}
          />
        );
      }}
    </Query>
  );
};

export default withApollo(PayersDropDown);
